import { MapPin, ChevronRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { BUSINESS, IMAGES, MANIFESTO } from "@/data/site";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative bg-[var(--bg)] py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        {/* Breadcrumb */}
        <nav aria-label="Breadcrumb" data-testid="about-breadcrumb" className="mb-10 flex items-center gap-1.5 text-xs text-[var(--ink-soft)]">
          <a href="#home" className="hover:text-[var(--green)]">Home</a>
          <ChevronRight size={13} />
          <span className="font-semibold text-[var(--green)]">About Us</span>
        </nav>

        <div className="grid gap-16 lg:grid-cols-[1fr_1.1fr] lg:gap-24">
          <div>
            <Reveal>
              <Overline>About M N Savanur</Overline>
              <h2 className="mt-5 font-display text-4xl font-bold leading-[1.05] tracking-tight text-[var(--ink)] sm:text-5xl">
                A trusted wholesale trader, rooted in <span className="italic text-[var(--green)]">Hubli’s</span> market yard.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-7 max-w-xl text-[var(--ink-soft)]">
                M N Savanur is a trusted vegetable supplier located inside APMC Yard, Amargol,
                Hubballi. We specialize in supplying fresh vegetables every day to homes, hotels,
                restaurants, caterers, retailers and bulk buyers. We focus on quality, freshness,
                competitive pricing and timely delivery — customer satisfaction is our highest priority.
              </p>
            </Reveal>

            <div className="mt-12 space-y-0 border-t border-[var(--border)]">
              {MANIFESTO.map((m, i) => (
                <Reveal key={m.no} delay={i * 0.08}>
                  <div className="group flex gap-6 border-b border-[var(--border)] py-7 transition-colors hover:bg-[var(--muted)]/50">
                    <span className="font-display text-2xl font-bold text-[var(--gold)]">{m.no}</span>
                    <div>
                      <h3 className="font-display text-xl font-semibold text-[var(--ink)]">{m.title}</h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-[var(--ink-soft)]">{m.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          {/* Imagery: real storefront + market */}
          <div className="relative">
            <Reveal y={60}>
              <figure className="clip-frame overflow-hidden rounded-3xl shadow-2xl shadow-black/10">
                <img
                  src={IMAGES.market}
                  alt="Fresh onion, potato, ginger and garlic at the APMC market"
                  className="aspect-[4/3] w-full object-cover"
                  loading="lazy"
                />
              </figure>
            </Reveal>

            <div className="mt-8 flex items-start gap-3 rounded-2xl border border-[var(--border)] bg-white/60 p-5">
              <MapPin className="mt-0.5 shrink-0 text-[var(--green)]" size={20} />
              <div>
                <p className="text-sm font-semibold text-[var(--ink)]">Visit our shop</p>
                <p className="text-sm text-[var(--ink-soft)]">
                  {BUSINESS.addressLines.join(" ")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
